module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "app-footer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideSct),
      expression: "hideSct"
    }]
  }, [_c('a', [_vm._v("SCT")]), _vm._v(" © 2019 R&D\n      "), _c('span', {
    staticClass: "float-right"
  }, [_vm._v("Powered by SCT")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-86282d5e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 479
// module chunks = 103